import type { Lang, Locale } from "@/service/translate/flights/flightTranslations.types"
import { getCseData } from "./cse"


export const getLnagForLocale = (locale: Locale, hostname: string): Lang => {

    if (hostname.includes("yoonly")) {
        switch (hostname) {
            case "www.nl.yoonly.eu":
            case "www.benl.yoonly.eu":
                return "yoonly-nl"
            case "dev.yoonly.eu":
            case "dev.befr.yoonly.eu":
            default:
                return "yoonly-fr"
        }
    }

    if ((locale as any) == 'en-US') locale = locale = "en-GB"
    if (locale == 'fr-FR-CSE') {
        const cseData = getCseData(locale)
        if (!cseData) {
            return 'fr'
        }
        return cseData.companyLang
    }

    switch (locale) {
        case "fr-FR":
            return 'fr'
        case "en-GB":
            return 'en'
        case "nl-NL":
            return 'nl'
    }
}
